import { login } from "../../services/auth";
import { push, replace, goBack } from "connected-react-router";
import { initPlayLists } from "./playList";
export const SET_USER = "SET_USER";
export function setUser(email, password) {
  return (dispatch) => {
    login({ email, password })
      .then((res) => res.json())
      .then((result) => {
        dispatch({ type: "SET_USER", payload: { user: result.user } });
        dispatch(initPlayLists());
      });
   
  };
}
